import api from './api';

export const retrieveRatingsMav = (mavData) =>
  api.post('/api/ratings/mav', mavData)
    .then(r => r.data)
    .catch(error => {
      console.error('Retrieve ratings mav error:', error);
      throw error;
    });

export const getRatings = (params) =>
  api.post('/api/admin/getratings', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get ratings error:', error);
      throw error;
    });

export const getRatingById = (ratingId) =>
  api.post('/api/admin/getrating', { ratingId })
    .then(r => r.data)
    .catch(error => {
      console.error('Get rating error:', error);
      throw error;
    });

export const createRating = (ratingData) =>
  api.post('/api/admin/createrating', ratingData)
    .then(r => r.data)
    .catch(error => {
      console.error('Create rating error:', error);
      throw error;
    });

export const updateRating = (ratingData) =>
  api.post('/api/admin/updaterating', ratingData)
    .then(r => r.data)
    .catch(error => {
      console.error('Update rating error:', error);
      throw error;
    });

export const deleteRating = (ratingId) =>
  api.post('/api/admin/deleterating', { ratingId })
    .then(r => r.data)
    .catch(error => {
      console.error('Delete rating error:', error);
      throw error;
    });
